import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '@hq-core/models/app-settings';
import { DataResource } from '@hq-custom-types';
import {
    ApiCollectionResponse,
    SearchState,
} from '@cia-front-end-apps/shared/api-interaction';
import { Observable } from 'rxjs';
import { Brand } from '../models/brand';

@Injectable()
export class BrandResource implements DataResource<Brand> {
    private readonly baseUrl: string;

    constructor(
        private http: HttpClient,
        private appSettings: AppSettings,
    ) {
        this.baseUrl = this.appSettings.apis.vendorData;
    }

    get(brandId: string): Observable<Brand> {
        return this.http.get<Brand>(`${this.baseUrl}/brands/${brandId}`);
    }

    create(brand: Brand): Observable<Brand> {
        return this.http.post<Brand>(`${this.baseUrl}/brands`, brand);
    }

    searchParentBrands(term: string, pageSize = 15): Observable<Brand[]> {
        const params = new HttpParams({ fromObject: { search: term, pageSize } });
        return this.http.get<Brand[]>(`${this.baseUrl}/brands/existing`, { params });
    }

    rollUp(newBrandId: number, parentBrandId: number): Observable<void> {
        return this.http.post<void>(`${this.baseUrl}/brands/${newBrandId}/roll-up`, { parentBrandId });
    }

    getAll(searchState: SearchState): Observable<ApiCollectionResponse<Brand>> {
        const url = `${this.baseUrl}/brands`;

        const params = new HttpParams({
            fromObject: {
                pageIndex: (searchState.pageIndex ?? 0).toString(),
                pageSize: (searchState.pageSize ?? 25).toString(),
                sortBy: searchState.sortBy ?? '',
                sortDirection: searchState.sortDirection ?? 'asc',
                search: searchState.search ?? '',
            },
        });

        return this.http.get<ApiCollectionResponse<Brand>>(url, { params });
    }
}
